import { LoadingLine } from "../../../components/loading-line.js";
import { UserPrivateMachineryModel } from "./model.js";
import { UserPrivateMachineryView } from "./view.js";
import { ITEM_OPTIONS } from "../../../config/constants.js";
import { ModalController } from "../../../components/modal/controller.js";
import { CheckInputValue } from "../../../config/functions.js";
import { LoadingDot } from "../../../components/loading-dot.js";
import { Doms } from "../../../components/doms.js";

export class UserPrivateMachineryController {
  constructor() {
    this.model = new UserPrivateMachineryModel();
    this.view = new UserPrivateMachineryView();
    this.loading = LoadingLine.getInstance();
    this.doms = new Doms();

    this.modal = null;
    this.openning = false;
  }

  loadMain() {
    app.userPrivateController.viewGenericItems.loadMain(this, "Mis máquinas", "maquinaria");
    history.pushState({}, "", `/user/maquinaria`);
    document.getElementById("btn-maquinaria").classList.add("active");
    document.getElementById("btn-header-maquinaria").classList.add("active");
  }

  new() {
    history.pushState({}, "", `/user/maquinaria/new`);
    this.modal = new ModalController("Publicar nueva máquina", LoadingDot.render() + '<br><br>', "form-maquinaria", app.userPrivateController.view.renderPublishButton("1"),);
    app.userPrivateController.auth
      .sessionAlive()
      .then(() => {
        this.modal.doms.content.innerHTML = this.view.renderForm();
        APICRUD.Common.Select.SetData("maquinaria-categoria", 0, ITEM_OPTIONS.Categorias.Maquinaria);
        APICRUD.Common.Select.SetData("maquinaria-unidad", 0, ITEM_OPTIONS.Unidades.Productos);
        APICRUD.Common.Select.SetData("maquinaria-tiene-envio", 0, ITEM_OPTIONS.TiposDeEnvios);
        APICRUD.Common.Select.SetData("maquinaria-moneda", 0, ITEM_OPTIONS.Monedas);
        APICRUD.Location.Selector_LoadStates("maquinaria-provincia", "5", "0");
        APICRUD.Location.Selector_LoadCities("maquinaria-localidad", "0", "0");
      })
      .catch((_error) => {
        console.log(_error);
        this.modal.doms.modal.innerHTML = "";
        this.modal.close();
        app.userPrivateController.auth.showLogin();
      });
  }

  create() {
    if (this.modal?.modal?.classList.contains("active")) {
      this.modal.doms.content.innerHTML = this.view.renderForm();
      this.view.gallery.checkButtons();
    } else {
      this.modal = new ModalController(
        "Publicar nueva máquina",
        this.view.renderForm(),
        "form-maquinaria",
        app.userPrivateController.view.renderPublishButton("1"),
      );
      this.modal.show();
      this.view.gallery.checkButtons();
    }
    APICRUD.Common.Select.SetData("maquinaria-categoria", 0, ITEM_OPTIONS.Categorias.Maquinaria);
    APICRUD.Common.Select.SetData("maquinaria-unidad", 0, ITEM_OPTIONS.Unidades.Productos);
    APICRUD.Common.Select.SetData("maquinaria-tiene-envio", 0, ITEM_OPTIONS.TiposDeEnvios);
    APICRUD.Common.Select.SetData("maquinaria-moneda", 0, ITEM_OPTIONS.Monedas);
    APICRUD.Location.Selector_LoadStates("maquinaria-provincia", "5", "0");
    APICRUD.Location.Selector_LoadCities("maquinaria-localidad", "0", "0");
  }

  edit(_idcod) {
    if (this.openning === true) return;
    this.openning = true;
    this.modal = new ModalController("Editar máquina", LoadingDot.render() + '<br><br>', "form-maquinaria", "<br>");
    this.modal.show();
    this.loading.show();
    this.model
      .read(_idcod)
      .then((maquina) => {
        this.modal.doms.content.innerHTML = this.view.renderForm(maquina.data);
        this.modal.doms.titleStatus.innerHTML = app.userPrivateController.view.renderPublishButton(
          maquina.data.visible,
        );
        this.view.gallery.checkButtons();
        APICRUD.Common.Select.SetData(
          "maquinaria-categoria",
          maquina.data.categoria,
          ITEM_OPTIONS.Categorias.Maquinaria,
        );
        APICRUD.Common.Select.SetData(
          "maquinaria-tiene-envio",
          maquina.data["tiene-envio"],
          ITEM_OPTIONS.TiposDeEnvios,
        );
        APICRUD.Common.Select.SetData("maquinaria-unidad", maquina.data.unidad, ITEM_OPTIONS.Unidades.Productos);
        APICRUD.Common.Select.SetData("maquinaria-moneda", maquina.data.moneda, ITEM_OPTIONS.Monedas);
        APICRUD.Location.Selector_LoadStates("maquinaria-provincia", "5", maquina.data.provincia);
        APICRUD.Location.Selector_LoadCities("maquinaria-localidad", maquina.data.provincia, maquina.data.localidad);
      })
      .catch((error) => {
        console.log(error);
        this.modal.close();
        let modal = new ModalController("Editar máquina", "No existe el máquina.");
        modal.show();
        setTimeout(modal.close.bind(this), 5000);
      })
      .finally(() => {
        this.openning = false;
        this.loading.hide();
      });
  }

  delete(_title, _idcod) {
    this.modalDelete = new ModalController("Eliminar máquina");
    this.modalDelete.doms.content.innerHTML = this.view.renderDeleteConfirmation(_title, _idcod);
  }

  deleteConfirmation(_idcod) {
    this.model
      .delete(_idcod)
      .then(() => {
        this.modal?.close();
        this.modalDelete?.close();
        app.userPrivateController.router("maquinaria");
      })
      .catch((_error) => {
        this.modalDelete.doms.content.innerHTML = _error;
        console.error(_error);
      });
  }

  deleteCancel() {
    this.modalDelete?.close();
  }

  save() {
    return new Promise(async (resolve, reject) => {
      let idcod = document.getElementById("maquinaria-idcod")?.value;
      let newData = {
        titulo: document.getElementById("maquinaria-titulo").value,
        resumen: document.getElementById("maquinaria-resumen").value,
        descripcion: document.getElementById("maquinaria-descripcion").value,
        imagenes: this.view.gallery.images,
        categoria: document.getElementById("maquinaria-categoria").value,
        precio: document.getElementById("maquinaria-precio").value,
        moneda: document.getElementById("maquinaria-moneda").value || "0",
        marca: document.getElementById("maquinaria-marca").value,
        modelo: document.getElementById("maquinaria-modelo").value,
        anio: document.getElementById("maquinaria-anio").value,
        kilometros: document.getElementById("maquinaria-kilometros").value,
        localidad: document.getElementById("maquinaria-localidad").value || "0",
        provincia: document.getElementById("maquinaria-provincia").value || "0",
        visible: document.getElementById("visible").checked === true ? "1" : "0",
      };

      if (idcod) {
        newData.idcod = idcod;
      }

      document.getElementById("maquinaria-titulo-error").innerHTML = "";
      document.getElementById("maquinaria-categoria-error").innerHTML = "";
      document.getElementById("maquinaria-resumen-error").innerHTML = "";
      document.getElementById("maquinaria-descripcion-error").innerHTML = "";
      document.getElementById("maquinaria-precio-error").innerHTML = "";
      document.getElementById("maquinaria-moneda-error").innerHTML = "";
      document.getElementById("maquinaria-kilometros-error").innerHTML = "";
      document.getElementById("maquinaria-marca-error").innerHTML = "";
      document.getElementById("maquinaria-modelo-error").innerHTML = "";
      document.getElementById("maquinaria-anio-error").innerHTML = "";
      document.getElementById("maquinaria-provincia-error").innerHTML = "";
      document.getElementById("maquinaria-localidad-error").innerHTML = "";
      document.getElementById("maquinaria-status").innerHTML = "";

      if (!newData.categoria || newData.categoria === "0") {
        document.getElementById("maquinaria-categoria-error").innerHTML = "Debe seleccionar una categoría.";
        document.getElementById("maquinaria-categoria").focus();
        return;
      } else if (!newData.titulo) {
        document.getElementById("maquinaria-titulo-error").innerHTML = "El título no puede estar vacío.";
        document.getElementById("maquinaria-titulo").focus();
        return;
      } else if (newData.titulo.length < 5) {
        document.getElementById("maquinaria-titulo-error").innerHTML = "El título debe tener al menos 5 caracteres.";
        document.getElementById("maquinaria-titulo").focus();
        return;
      } else if (!newData.resumen) {
        document.getElementById("maquinaria-resumen-error").innerHTML = "La descripción corta no puede estar vacía.";
        document.getElementById("maquinaria-resumen").focus();
        return;
      } else if (newData.resumen.length < 20) {
        document.getElementById("maquinaria-resumen-error").innerHTML =
          "La descripción debe tener al menos 20 caracteres.";
        document.getElementById("maquinaria-resumen").focus();
        return;
      } else if (newData.kilometros.trim() == "") {
        document.getElementById("maquinaria-kilometros-error").innerHTML = "Debe indicar los kilómetos.";
        document.getElementById("maquinaria-kilometros").focus();
        return;
      } else if (document.getElementById("maquinaria-precio-radio-1").checked == true) {
        if (newData.precio.trim() == "" || newData.precio.trim() == "0") {
          document.getElementById("maquinaria-precio-error").innerHTML = "El precio no puede estar vacío.";
          document.getElementById("maquinaria-precio").focus();
          return;
        } else if (!CheckInputValue("maquinaria-precio")) {
          document.getElementById("maquinaria-precio-error").innerHTML = "El precio no puede ser menor a cero.";
          document.getElementById("maquinaria-precio").focus();
          return;
        } else if (newData.moneda === "0") {
          document.getElementById("maquinaria-moneda-error").innerHTML = "Debe seleccionar una moneda.";
          document.getElementById("maquinaria-moneda").focus();
          return;
        }
      } else if (!newData.marca) {
        document.getElementById("maquinaria-marca-error").innerHTML = "Debe ingresar la marca.";
        document.getElementById("maquinaria-marca").focus();
        return;
      } else if (!newData.modelo) {
        document.getElementById("maquinaria-modelo-error").innerHTML = "Debe ingresar el modelo.";
        document.getElementById("maquinaria-modelo").focus();
        return;
      } else if (!newData.anio) {
        document.getElementById("maquinaria-anio-error").innerHTML = "Debe ingresar el año.";
        document.getElementById("maquinaria-anio").focus();
        return;
      } else if (CheckInputValue("maquinaria-anio")) {
        if (parseInt(document.getElementById("maquinaria-anio").value) < 1950) {
          document.getElementById("maquinaria-anio-error").innerHTML = "El año no es válido.";
          document.getElementById("maquinaria-anio").focus();
          return;
        }
      }

      document.getElementById("maquinaria-status").innerHTML = "Guardando...";

      let func = "Create";
      let text = "Creando nueva máquina";
      if (newData.idcod) {
        func = "Update";
        text = "Guardando máquina";
      }

      if (await app.userPrivateController.account.canPublish(this.doms.getDom('visible').checked, newData.idcod) === false) {
        document.getElementById('visible').checked = false;
        newData.visible = '0';
      }

      let modalSave = new ModalController("Guardando", "Enviando datos, por favor espere...");
      modalSave.show();
      this.loading.show(text);
      this.model
        .save(newData, func)
        .then((_result) => {
          document.getElementById("maquinaria-status").innerHTML = "Datos guardados.";
          app.userPrivateController.router("maquinaria");
          app.userPrivateController.maquinaria.modal.close();
          modalSave.doms.content.innerHTML = "Datos guardados.";
          resolve();
        })
        .catch((_error) => {
          document.getElementById("maquinaria-status").innerHTML = _error;
          modalSave.doms.content.innerHTML = _error;
          reject();
        })
        .finally(() => {
          this.loading.hide();
          modalSave.close();
        });
    });
  }
}
